module.exports = require('./dibsBackbone');



//////////////////
// WEBPACK FOOTER
// ./~/dibs-backbone/index.js
// module id = 3
// module chunks = 64